import { render } from "./DesignersForm.vue?vue&type=template&id=54032bb4&scoped=true&ts=true"
import script from "./DesignersForm.vue?vue&type=script&lang=ts"
export * from "./DesignersForm.vue?vue&type=script&lang=ts"

import "./DesignersForm.vue?vue&type=style&index=0&id=54032bb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54032bb4"]])

export default __exports__